// extracted by mini-css-extract-plugin
export default {"listItem":"DropdownMenuItem_listItem__99bAV","button":"DropdownMenuItem_button__k6BgV","titleStyles":"DropdownMenuItem_titleStyles__xL+kE","text":"DropdownMenuItem_text__zFsID"};